<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  reportsMethods,
  reportsComputed,
  exportMethods,
  erpFixMessages,
  mopMethods,
  mopComputed,
  kantoAdsMethods,
  kantoAdsComputed,
} from "@/state/helpers";
import Swal from "sweetalert2";
// import moment from 'moment';


export default {
  page: {
    title: "Kanto Ads Topup",
  },
  data() {
    return {
      mcpTopups: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: true,
      sortOrder: "DESC",
      sortingValue: {
        sort: "id",
        orderDesc: true,
      },
      fields: [
        {
          key: "request_ref_no",
          label: "Request Reference No.",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "brand_owner",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "user_email",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "brand_mobile",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "transaction_date",
          label: "Transaction Date & Time",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "status",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "chosen_bank",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "amount",
          label: "Top-Up Amount",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "reference_number",
          label: "Bank Reference Number",
          sortable: true,
          tdClass: "align-middle",
        },

        {
          key: "proof_of_payment",
          sortable: false,
          tdClass: "align-middle",
        },

        {
          key: "remarks",
          sortable: true,
          tdClass: "align-middle",
        },
      ],
      isSearching: false,
      searchValue: {
        searchField: null,
        keyword: "",
        status: null,
        dateRange: null,
        sort: "id",
        orderDesc: true,
      },
      searchList: [
        { text: "Search All", value: null },
        { text: "Brand Owner", value: "organization_name" },
        { text: "User Email", value: "user_email" },
        { text: "Brand Mobile", value: "brand_mobile" },
        { text: "Chosen Bank", value: "bank_name" },
        { text: "Reference Number", value: "reference_no" },
      ],
      statusOptions: [
        { text: "All", value: null },
        { text: "Confirmed", value: "confirmed" },
        { text: "Pending", value: "pending" },
        { text: "On Hold", value: "on hold" },
        { text: "Declined", value: "declined" },
      ],
      paymentOptions: [{ text: "All", value: null }],
      isRange: null,
      rangeOptions: {
        mode: "range",
      },
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    ...mopComputed,
    ...kantoAdsComputed,
    rows() {
      return this.dataList.length;
    },
  },
  async mounted() {
    this.getTopups();
    this.changeTitle({ title: "Top-up Bank Transfer" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Kanto Ads", to: { name: "" } },
        { text: "Topup Transactions", to: { name: "Topup Transaction" } },
      ],
    });
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...mopMethods,
    ...kantoAdsMethods,
    async getTopups() {
      let params = {
        page: this.isSearching ? 1 : this.currentPage,
        limit: this.isSearching ? 10 : this.perPage,
        search: this.searchValue,
        sortBy: this.isSearching ? "" : this.sortBy,
        sortOrder: this.isSearching ? "DESC" : this.sortOrder,
      };

      await this.getMcpTopupLogs(params).then(() => {
        this.mcpTopups = this.mcpTopupLogs;
      });

      this.isSearching = false;
    },
    async onExport() {
      let params = {
        module: "kantoads_topup_logs",
        email: JSON.parse(localStorage.getItem("userData")).email,
        search: this.searchValue,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
      };

      this.exportReport(params)
        .then(() =>
          Swal.fire(
            "Success!",
            `Your request for report is pending. It will be sent to your email once it's ready.`,
            "success"
          )
        )
        .catch(() =>
          Swal.fire(
            "Failed!",
            `Your request for reports has failed.`,
            "warning"
          )
        );
    },
    async tableSorting(action) {
      var column = "";
      switch (action.sortBy) {
        case "brand_owner":
          column = "organization_name";
          break;
        case "user_email":
          column = "user_email";
          break;
        case "brand_mobile":
          column = "brand_mobile";
          break;
        case "transaction_date":
          column = "created_at";
          break;
        case "chosen_bank":
          column = "bank_name";
          break;
        case "amount":
          column = "amount";
          break;
        case "reference_number":
          column = "reference_no";
          break;
        case "status":
          column = "status";
          break;
        case "remarks":
          column = "remarks";
          break;
      }

      this.sortBy = column;
      this.sortOrder = action.sortDesc ? "DESC" : "ASC";
      await this.getTopups();
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{
                      mcpTopupLogsTotalRows
                    }}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right">
                <button class="btn btn-secondary" @click="getTopups">
                  <feather
                    type="refresh-ccw"
                    size="16"
                    class="icon nav-icon"
                  ></feather
                  >&nbsp;&nbsp; Refresh
                </button>
              </div>
              <!-- Search and button -->
              <div class="d-flex flex-row mt-3 mb-2 px-3 ta-right">
                <b-form-group description="Search Keyword" class="me-2">
                  <form class="d-flex" @submit.prevent="getTopups">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none"
                        style="width: fit-content"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchList"
                      ></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input
                        class="rounded-0 rounded-end"
                        v-model="searchValue.keyword"
                      ></b-form-input>
                    </b-input-group>
                  </form>
                </b-form-group>

                <b-form-group
                  label-for="status"
                  description="Filter by status"
                  class="me-2 w-status"
                >
                  <b-form-select
                    class="form-select rounded-0 rounded-start rounded-end shadow-none"
                    v-model="searchValue.status"
                    :options="statusOptions"
                  ></b-form-select>
                </b-form-group>

                <b-form-group description="Filter by date added" class="me-2">
                  <flat-pickr
                    v-model="searchValue.dateRange"
                    :config="rangeOptions"
                    placeholder="Select a date range"
                    class="form-control"
                    style="width: fit-content"
                  ></flat-pickr>
                </b-form-group>

                <b-button
                  variant="primary"
                  class="h-fit me-2 d-flex flex-row"
                  @click="getTopups"
                >
                  <i class="bx bx-search me-1 mt-1"></i>Search
                </b-button>
                <b-button
                  variant="primary"
                  class="h-fit me-2 d-flex flex-row"
                  @click="
                    isSearching = true;
                    onExport();
                  "
                >
                  <i class="uil uil-export me-1"></i>
                  Export
                </b-button>
              </div>
            </div>
            <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="mcpTopups"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSorting"
                >
                  <template #cell(request_ref_no)="data">
                    <div>{{ data.item.supp_ref_no }}</div>
                  </template>

                  <template #cell(brand_owner)="data">
                    <div>
                      <b-link
                        @click="
                          $router.push({
                            path: `/kanto-ads/topup/update/${data.item.id}`,
                          })
                        "
                      >
                        {{ data.item.organization_name }}
                      </b-link>
                    </div>
                  </template>

                  <template #cell(user_email)="data">
                    <div>{{ data.item.user_email }}</div>
                  </template>

                  <template #cell(brand_mobile)="data">
                    <div>{{ data.item.brand_mobile }}</div>
                  </template>

                  <template #cell(transaction_date)="data">
                    <div>{{ data.item.created_at | formatDate }}</div>
                  </template>

                  <template #cell(chosen_bank)="data">
                    <div>{{ data.item.bank_name }}</div>
                  </template>

                  <template #cell(amount)="data">
                    <div>₱{{ data.item.amount }}</div>
                  </template>

                  <template #cell(reference_number)="data">
                    <div>{{ data.item.reference_no }}</div>
                  </template>

                  <template #cell(proof_of_payment)="data">
                    <div class="d-flex justify-content-center">
                      <b-img
                        :src="data.item.proof_photo"
                        @error="(e) => (e.target.src = require('@/assets/images/img-placeholder.png'))"
                        alt=""
                        thumbnail
                        height=50
                        width=50
                      >
                      </b-img>
                      <!-- {{ data.item.proof_photo }} -->
                    </div>
                  </template>

                  <template #cell(status)="data">
                    <div
                      :class="{
                        'pending-color-code': data.item.status == 'pending',
                        'on-hold-color-code': data.item.status == 'on hold',
                        'confirmed-color': data.item.status == 'confirmed',
                        'declined-color-code': data.item.status == 'declined',
                      }"
                      class="text-capitalize"
                    >
                      {{ data.item.status != null || data.item.status != "" ? data.item.status : data.item.status = 'pending' }}
                    </div>
                  </template>

                  <template #cell(remarks)="data">
                    <div class="text-truncate" style="width: 120px">
                      {{ data.item.remarks != null ? (data.item.remarks).charAt(0).toUpperCase() + data.item.remarks.slice(1) : '' }}
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="mcpTopupLogsTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div
              class="row g-0 text-center text-sm-start"
              v-if="mcpTopupLogsTotalRows > 10"
            >
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label"
                        >Display:</label
                      >
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select
                            class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="getTopups"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                      v-if="mcpTopupLogsTotalRows > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="mcpTopupLogsTotalRows"
                        @input="getTopups"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style scoped>
.custom-checkbox-method label {
  margin-left: 10px;
}

.custom-checkbox-method input {
  margin-left: 15px;
}

.required-input {
  color: red;
}

.calendar-icon {
  display: block;
  font-size: 20px;
  padding: 8px;
  background-color: grey;
}

.w-status {
  width: 11.875rem;
}

.pending-color-code {
  color: #831118 !important;
}

.on-hold-color-code {
  color: #dc7512 !important;
}

.confirmed-color {
  color: #508f30 !important;
}

.declined-color-code {
  color: #868686 !important;
}
</style>
